import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {HashService} from './services/core/hash.service';
import {LocalStorageService} from './services/core/local-storage.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {HttpErrorInterceptor} from './interceptors/http-error.interceptor';
import {NgxSpinnerModule} from 'ngx-spinner';
import {ToastrModule} from 'ngx-toastr';
import { DrawingNotificationsComponent } from './modules/shared/drawing-notifications/drawing-notifications.component';
import {AuthInterceptor} from './interceptors/auth.interceptor';
//import {ModalPopupService} from "./services/core/modal-popup.service";
import {DatePipe} from "@angular/common";
import {CalculationService} from "./services/calculation.service";
import { SignalProvider } from './services/realtime/signal-provider.interface';
import { FirebaseSignalProvider } from './services/realtime/firebase-signal.provider';
import {NgDialogAnimationService} from 'src/app/services/core/ng-dialog-animation.service';
import {MatDialogModule} from "@angular/material/dialog";
import {ReactiveFormsModule} from "@angular/forms";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatSelectModule} from "@angular/material/select";
import {NgSelectModule} from "@ng-select/ng-select";
import {OVERLAY_DEFAULT_CONFIG} from "@angular/cdk/overlay";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatNativeDateModule} from "@angular/material/core";
import {SharedModule} from "./modules/shared/shared.module";
import { GlobalScreenshotModule } from './modules/shared/global-screenshot/global-screenshot.module';
import { RouterModule } from '@angular/router';
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {UnauthorizedInterceptor} from "./interceptors/unauthorized.interceptor";
import {CancelOnNavigationInterceptor} from "./interceptors/cancel-on-navigation.interceptor";
import { PdfViewerModule } from 'ng2-pdf-viewer';
// import { environment } from 'src/environments/environment';
// import { ImageEditorModule } from '@syncfusion/ej2-angular-image-editor';
// import {CityValueMaskDirective} from "./modules/shared/directives/city-value-mask/city-value-mask.directive";



import {StepperAllModule, StepperModule} from '@syncfusion/ej2-angular-navigations'
import { FirebaseMessagingService } from './services/core/notification/firebase-messaging.service';
import { AudioMiniPlayerComponent } from './modules/shared/audio-mini-player/audio-mini-player.component';

@NgModule({ declarations: [
        DrawingNotificationsComponent,
        AppComponent,
        // CityValueMaskDirective
    ],
    exports: [],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        AudioMiniPlayerComponent,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        NgxSpinnerModule,
        MatDialogModule,
        MatCheckboxModule,
        MatSelectModule,
        NgSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        ToastrModule.forRoot(),
        SharedModule,
        GlobalScreenshotModule,
        MatProgressSpinnerModule,
        RouterModule.forRoot([]),
        PdfViewerModule], providers: [
        HashService,
        LocalStorageService,
        FirebaseMessagingService,
        MatDatepickerModule,
        //ModalPopupService,
        DatePipe,
        NgDialogAnimationService,
        // Angular CDK 21 renders overlays into the browser top layer (Popover API),
        // which paints above all normal-DOM content regardless of z-index. That hides
        // body-level floating UI inside dialogs — e.g. Google Places autocomplete
        // (.pac-container) and body-appended ng-select panels. This app manages stacking
        // via explicit z-index, so opt back into classic z-index overlay stacking.
        {
            provide: OVERLAY_DEFAULT_CONFIG,
            useValue: { usePopover: false },
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: UnauthorizedInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: CancelOnNavigationInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
        // Real-time Signal Bus transport. Swap to SupabaseSignalProvider here
        // (one line) to migrate off Firebase — components depend only on the
        // abstract SignalProvider.
        { provide: SignalProvider, useClass: FirebaseSignalProvider },
    ] })
export class AppModule { }
